<div class="ancillary-all-benefits" [class.no-actions]="!isBundleSelectActions">
  <div class="ancillary-all-benefits-body d-flex align-items-center flex-column">
    <div class="d-flex justify-content-end pb-4 w-100">
      <div (click)="close.emit()">
        <img height="28" width="28" src="/assets/icons/close_travalign.svg" alt="close" />
      </div>
    </div>

    <img
      class="pb-6"
      height="160"
      width="160"
      src="assets/images/{{ data.img }}.webp"
      alt="ancillary-all-benefits-img"
    />

    <div class="d-flex flex-column g-3">
      <h2 class="semi-bold">{{ data.title }}</h2>
      <p [innerHTML]="data.description"></p>

      @for (feature of data.features; track feature.title) {
        <div class="d-flex g-2">
          <img height="16" width="16" src="assets/icons/check-blue.svg" alt="check" />
          <div class="d-flex flex-column g-1">
            @if (!data.isWarning) {
              <p class="semi-bold">{{ feature.title }}</p>
              <p class="caption" [innerHTML]="feature.description"></p>
            } @else {
              <p>{{ feature.title }}</p>
            }
          </div>
        </div>
      }
      @if (discountSize && isBundleSelectActions) {
        <p class="semi-bold text-green-800">
          Upgrade to bundle & save {{ discountSize }}% instantly
        </p>
      }
    </div>
  </div>

  @if (isBundleSelectActions) {
    <div class="ancillary-all-benefits-actions w-100">
      <ds-button
        (click)="continueWithoutBundle.emit()"
        [fullWidth]="true"
        data-id="continue-without-bundle"
        label="Continue without bundle"
      />

      <ds-button
        (click)="continueWithBundle.emit()"
        variant="secondary"
        [fullWidth]="true"
        data-id="continue-with-bundle"
        label="Add bundle"
      />
    </div>
  }
</div>
